import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './admin/contexts/AuthContext';
import { Layout } from './layout/Layout';
import { ProjectsPage } from './pages/ProjectsPage';
import { ContactsPage } from './pages/ContactsPage/ContactsPage';
import { NewsPage } from './pages/NewsPage/NewsPage';
import { NewsItem } from './components/NewsItem/NewsItem';
import { ProjectsItem } from './components/ProjectItem/ProjectItem';
import { AdminApp } from './admin/AdminApp';

function App() {
    return (
        <BrowserRouter>
            <AuthProvider>
                <Routes>
                    <Route path="/" element={<Layout />}>
                        <Route index element={<ProjectsPage />} />
                        <Route path="contacts" element={<ContactsPage />} />
                        <Route path="news" element={<NewsPage />} />
                        <Route path="news/:id" element={<NewsItem />} />
                        <Route path="project/:id" element={<ProjectsItem />} />
                    </Route>
                    <Route path="/admin/*" element={<AdminApp />} />
                </Routes>
            </AuthProvider>
        </BrowserRouter>
    );
}

export default App;